import * as React from "react";
import { forwardRef } from "react";
const SvgCharging = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M0 27.598v44.804h36.607l.313-5.9-12.293-.65 13.154-38.254H10Zm63.393 0-.313 5.9 12.293.65-13.154 38.254h29.885V61.203H100V38.797h-7.896v-11.2H67.967Zm-15.174 13.97-3.748 10.9 7.605.403-.295 5.56 3.748-10.9-7.605-.402z" />
    <path d="m41.865 100 23.587-57.706-9.95-.443L58.135 0 34.548 57.706l9.95.443Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgCharging);
export default ForwardRef;
